import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { WeaveThemeProvider } from '@weave/platform-ui-components';

import { AppRouterContainer } from './components/app-router-container/app-router.container';
import { store } from './redux/store';
import { unregister } from './registerServiceWorker';
import './styles.css';

const jsx = (
  <div>
    <Provider store={store}>
      <WeaveThemeProvider>
        <AppRouterContainer />
      </WeaveThemeProvider>
    </Provider>
  </div>
);

ReactDOM.render(jsx, document.getElementById('root'));

// For now, we are opting out of using the service worker
// We could change this for production later if we want the improved performance
unregister();
